declare var swal: any;
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActorService } from '../../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, GuardianInfoController, GuardianInfoRequest, SaveCustomerMessageRequest, CustomerMessageRequest, CustomerMessageController, OTFormDetailByReportCodeController, OTFormDetailByReportCodeRequest, SectionData, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, CycleOocyteQualityBetweenDateController, CycleOocyteQualityBetweenDateRequest, SingleWellInseminationByCycleController, SingleWellInseminationByCycleRequest, SaveSingleWellInseminationInfoRequest, IvfCycleInseminationLogByCycleWithDOCController, IvfCycleInseminationLogByCycleWithDOCRequest, SaveIvfCycleInseminationLogRequest, CompleteIvfCycleInseminationRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, CycleSpermPreparationBetweenDateController, CycleSpermPreparationBetweenDateRequest, TreatmentCycleStatusController, TreatmentCycleStatusRequest, IvfCycleInseminationByCycleController, IvfCycleInseminationByCycleRequest, SaveIvfCycleInseminationInfoRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest } from '../../../../models/actor/actor';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { NgbdUploadActorImageModal } from '../../../../../modals/uploadactorimage/ngbuploadactorimage.modal';
import { ActorPersonalInfoController, ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { AppFeaturesList } from '../../../../constants/constants';
//import  './profilesteps.js';
import { HCPService } from '../../../../services/hcp.service';
declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
//import { NgbTcDetailsModal } from '../tcdetails.modal';
//import { NgbEventAddModal } from './eventadd.modal';
import { FdActorReportsDocController, FDActorDocRequest } from '../../../../../../../src/app/ncs/models/formdesign/fd.model';
import { FDService } from '../../../../../../../src/app/ncs/services/fd.service';
import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';
import { NgbAddInseminationLogModal } from './addinseminationlog.modal';
import { NgbEditInseminationLogModal } from './editinseminationlog.modal';
import { NgbEditInsemiModal } from './editinsemi.modal';
import { InseminationPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'ivfinseminationedit',
  templateUrl: './ivfinseminationedit.component.html',
  styleUrls: ['./ivfinseminationedit.component.scss'],
  animations: [routerTransition()]
})

export class IvfInseminationEditComponent implements OnInit, AfterViewInit {

  //Variable Declaration
  currentPage: string = "About"
  public isRequesting: boolean = false;
  CurrentActorProfileRequest: ActorProfileRequest;
  CurrentActorProfileController: ActorProfileController;
  CurrentCompleteIvfCycleInseminationRequest: CompleteIvfCycleInseminationRequest;
  //CurrentFdActorReportsDocController: FdActorReportsDocController[];
  //CurrentFDActorDocRequest: FDActorDocRequest;
  public ApiResData: ApiResponseModel;

  ValueChangeActorPersonalInfoController: ActorPersonalInfoController;
  ValueChangeActorImageController: ActorImageController;
  CurrentSaveSingleWellInseminationInfoRequest: SaveSingleWellInseminationInfoRequest;
  CurrentSaveIvfCycleInseminationLogRequest: SaveIvfCycleInseminationLogRequest;
  CurrentEditIvfCycleInseminationInfoRequest: SaveIvfCycleInseminationInfoRequest;
  @Input() NurseActorCode: number = 0;
  @Input() ActorCode: number;
  @Input() CycleCode: number;
  @Input() Duration: number;
  @Input() FormattedCode: number;
  @Input() DisplayName: string;
  searchTitle: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  //
  //public FormattedCode: number = 0;
  public IsSetAccessRights: boolean;
  public IsSelected: boolean;
  public marked: boolean = false;
  public CanEditProfileInfo: number = 0;
  public CanEditContactInfo: number = 0;
  public CanShowProfileInfo: number = 0;
  public CanShowContactInfo: number = 0;
  public Code: string;
  public PatientActorCode: number;
  public PatientCycleCode: number;
  public CanLoadReport: boolean = true;
  public CanShowProfileSummary: number = 0;
  public CanEditProfileSummary: number = 0;

  public CanShowJobPreferences: number = 0;
  public CanEditJobPreferences: number = 0;

  public CanShowEducation: number = 0;
  public CanEditEducation: number = 0;

  public CanShowEmploymentHistory: number = 0;
  public CanEditEmploymentHistory: number = 0;

  public CanShowReferences: number = 0;
  public CanEditReferences: number = 0;

  public CanShowIdentities: number = 0;
  public CanEditIdentities: number = 0;

  public CanShowCertifications: number = 0;
  public CanEditCertifications: number = 0;

  public CanShowMedicalFitness: number = 0;
  public CanEditMedicalFitness: number = 0;

  public CanShowProfileImage: number = 0;
  public CanEditProfileImage: number = 0;
  public length: number;
  public CanShowLegalinfo: number = 0;
  public CanEditLegalinfo: number = 0;
  public showprofile: boolean = true;
  public showmessages: boolean = false;
  public ScanDetails: boolean = false;
  public Showscan: boolean = true;
  public ShowIninsemination: boolean = true;
  public Showivf: boolean = false;
  //
  TodayDate = new Date();


  CurrentFdActorReportsDocController: FdActorReportsDocController[];
  CurrentFDActorDocRequest: FDActorDocRequest;

  LoadForms() {
    this.CurrentFDActorDocRequest = new FDActorDocRequest();
    this.CurrentFdActorReportsDocController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentFDActorDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetFdActorReportsDocController();
  }
  public SelectedReport: string;
  //public SelectedActorCode: number = 92;
  GetFdActorReportsDocController() {
    this.StartRefreshing();

    this.CurrentFDActorDocRequest.ActorCode = 92;
    //this.CurrentFDActorDocRequest.ActorReportCode = null;
    //this.CurrentFDActorDocRequest.ActorReportTemplateCode = null;
    this.CurrentFDActorDocRequest.CreatedUserName = AppData.Instance().UserLoginDetails.DisplayName;
    this.CurrentFDActorDocRequest.ConditionalOperator = 11;
    //alert(this.FormattedCode);
    this.fdservice.GetFdActorReportsDocController(this.CurrentFDActorDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFdActorReportsDocController = this.ApiResData.Result;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadPatients();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }



  //CurrentCycleOocyteQualityBetweenDateController: CycleOocyteQualityBetweenDateController[];
  //CurrentCycleOocyteQualityBetweenDateRequest: CycleOocyteQualityBetweenDateRequest;
  //LoadPatients2() {
  //  this.CurrentCycleOocyteQualityBetweenDateRequest = new CycleOocyteQualityBetweenDateRequest();

  //  this.CurrentCycleOocyteQualityBetweenDateRequest.FacilityCode = AppData.Instance().UserLoginDetails.EmpFacilityCode;

  //  this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;


  //  this.CurrentCycleOocyteQualityBetweenDateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
  //  this.GetCycleOocyteQualityBetweenDateController();
  //}

  //GetCycleOocyteQualityBetweenDateController() {
  //  this.StartRefreshing();
  //    this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
  //    this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

  //  this.actorservice.GetCycleOocyteQualityBetweenDateController(this.CurrentCycleOocyteQualityBetweenDateRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentCycleOocyteQualityBetweenDateController = this.ApiResData.Result;
  //        this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;

  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );
  //}
  CurrentCycleSpermPreparationBetweenDateController: CycleSpermPreparationBetweenDateController[];
  CurrentCycleSpermPreparationBetweenDateRequest: CycleSpermPreparationBetweenDateRequest;
  LoadPatients2() {
    this.CurrentCycleSpermPreparationBetweenDateRequest = new CycleSpermPreparationBetweenDateRequest();

    this.CurrentCycleSpermPreparationBetweenDateRequest.FacilityCode = AppData.Instance().SelectedBranchCode;

    this.CurrentCycleSpermPreparationBetweenDateRequest.ConditionalOperator = 10;


    this.CurrentCycleSpermPreparationBetweenDateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.pdata = this.CurrentCycleSpermPreparationBetweenDateController;
    this.GetCycleSpermPreparationBetweenDateController();
  }

  GetCycleSpermPreparationBetweenDateController() {
    this.StartRefreshing();
    this.CurrentCycleSpermPreparationBetweenDateRequest.FromDate = new Date();
    this.CurrentCycleSpermPreparationBetweenDateRequest.ToDate = new Date();

    this.actorservice.GetCycleSpermPreparationBetweenDateController(this.CurrentCycleSpermPreparationBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCycleSpermPreparationBetweenDateController = this.ApiResData.Result;
          this.pdata = this.CurrentCycleSpermPreparationBetweenDateController;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  constructor(private router: Router,
    public printService: PrintService, private spinner: NgxSpinnerService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService, private hcpservice: HCPService, private fdservice: FDService, private tosterservice: NGXToastrService,
    private modalService: NgbModal, private filter: InseminationPipe, private parserFormatter: NgbDateParserFormatter) {

    //stepObject.init();
    //webGlObject.init();
  }


  ngOnInit() {

    $.getScript('./healins-assets/js/jquery.steps.js');
    $.getScript('./healins-assets/js/profilesteps.js');
    this.CurrentFDActorDocRequest = new FDActorDocRequest();
    ///////////////////////
    //this.LoadForms();
    this.LoadPatients2();
    //this.LoadPatients();
    ///this.LoadClinics();
    //this.LoadMessages();
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.PatientActorCode = this.ActorCode;
    this.PatientCycleCode = this.CycleCode;
    this.CurrentSaveSingleWellInseminationInfoRequest = new SaveSingleWellInseminationInfoRequest();
    this.CurrentSaveSingleWellInseminationInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveIvfCycleInseminationLogRequest = new SaveIvfCycleInseminationLogRequest();

    this.CurrentSaveIvfCycleInseminationLogRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentEditIvfCycleInseminationInfoRequest = new SaveIvfCycleInseminationInfoRequest();
    this.CurrentEditIvfCycleInseminationInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentCompleteIvfCycleInseminationRequest = new CompleteIvfCycleInseminationRequest();
    this.CurrentCompleteIvfCycleInseminationRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.onSetFeatureAccessConfig();

    this.CurrentActorProfileRequest = new ActorProfileRequest();
    this.CurrentActorProfileController = new ActorProfileController();
    if (this.NurseActorCode > 0) {
      this.CurrentActorProfileRequest.ActorCode = this.NurseActorCode;
    }
    else {
      this.CurrentActorProfileRequest.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    }
    this.CurrentActorProfileRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.ValueChangeActorPersonalInfoController = new ActorPersonalInfoController();
    this.ValueChangeActorImageController = new ActorImageController();
    // Horizontal Timeline js for user timeline
    //$.getScript('./assets/js/vertical-timeline.js');
    //



  }
  FormData: SectionData[];
  CurrentOTFormDetailByReportCodeController: OTFormDetailByReportCodeController[];
  CurrentOTFormDetailByReportCodeRequest: OTFormDetailByReportCodeRequest;
  LoadClinics(reportCode: string) {

    var r1: OTFormDetailByReportCodeRequest = new OTFormDetailByReportCodeRequest();
    r1.ConditionalOperator = 10;

    r1.PatientReportCode = this.Code;
    r1.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.GetOTFormDetailByReportCodeController(r1).subscribe
      ((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.stopRefreshing();
          //  this.CurrentOTFormDetailByReportCodeController = this.ApiResData.Result;
          //alert(this.CurrentOTFormDetailByReportCodeController);
          // var reportCode: number = this.CurrentOTFormsByFormattedCodeController[0].PatientReportCode;
          this.FormData = this.ApiResData.Result;
          //if (this.FormData.length > 0)
          //  alert(this.FormData[0].Title);
          //else {
          //  alert("no data retrieved");
          //}



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }


  onAssignedToActorCode(event: any) {

    if (event != null) {
      //alert(this.SelectedReport);
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      //this.CurrentFdActorReportsDocController[0].TemplateName = event;
      // console.log('event--_>' + event);
      //   }
      this.Code = this.SelectedReport;
      this.LoadClinics(this.Code);
    }

  }

  ngAfterViewInit() {
    // pSteps.loadStep();
  }

  onSetFeatureAccessConfig() {


    //Features
    var PersonalInfo_FeaturesList = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_PersonalInfo.toUpperCase())
    var ContactInfo_FeaturesList = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ContactInfo.toUpperCase())

    //
    var Feature_NurseProfile_ProfileSummary = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ProfileSummary.toUpperCase())
    var Feature_NurseProfile_JobPreferences = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_JobPreferences.toUpperCase())

    var Feature_NurseProfile_Education = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Education.toUpperCase())

    var Feature_NurseProfile_EmploymentHistory = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_EmploymentHistory.toUpperCase())

    var Feature_NurseProfile_References = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_References.toUpperCase())

    var Feature_NurseProfile_Identities = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Identities.toUpperCase())
    var Feature_NurseProfile_Certifications = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Certifications.toUpperCase())

    var Feature_NurseProfile_MedicalFitness = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_MedicalFitness.toUpperCase())

    var Feature_NurseProfile_ProfileImage = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ProfileImage.toUpperCase())

    var Feature_NurseProfile_Legalinfo = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Legalinfo.toUpperCase())


    //

    if (PersonalInfo_FeaturesList.length > 0) {
      if (PersonalInfo_FeaturesList[0].Edit === true) {
        this.CanEditProfileInfo = 1;
      }
      if (PersonalInfo_FeaturesList[0].List === true) {
        this.CanShowProfileInfo = 1;
        //this.GetActorPersonalDetailInfoController();
      }
    }
    if (ContactInfo_FeaturesList.length > 0) {
      if (ContactInfo_FeaturesList[0].Edit === true) {
        this.CanEditContactInfo = 1;
      }
      if (ContactInfo_FeaturesList[0].List === true) {
        this.CanShowContactInfo = 1;
      }
    }

    //
    if (Feature_NurseProfile_ProfileSummary.length > 0) {
      if (Feature_NurseProfile_ProfileSummary[0].Edit === true) {
        this.CanEditProfileSummary = 1;
      }
      if (Feature_NurseProfile_ProfileSummary[0].List === true) {
        this.CanShowProfileSummary = 1;
      }
    }

    if (Feature_NurseProfile_JobPreferences.length > 0) {
      if (Feature_NurseProfile_JobPreferences[0].Edit === true) {
        this.CanEditJobPreferences = 1;
      }
      if (Feature_NurseProfile_JobPreferences[0].List === true) {
        this.CanShowJobPreferences = 1;
      }
    }

    if (Feature_NurseProfile_Education.length > 0) {
      if (Feature_NurseProfile_Education[0].Edit === true) {
        this.CanEditEducation = 1;
      }
      if (Feature_NurseProfile_Education[0].List === true) {
        this.CanShowEducation = 1;
      }
    }

    if (Feature_NurseProfile_EmploymentHistory.length > 0) {
      if (Feature_NurseProfile_EmploymentHistory[0].Edit === true) {
        this.CanEditEmploymentHistory = 1;
      }
      if (Feature_NurseProfile_EmploymentHistory[0].List === true) {
        this.CanShowEmploymentHistory = 1;
      }
    }

    if (Feature_NurseProfile_References.length > 0) {
      if (Feature_NurseProfile_References[0].Edit === true) {
        this.CanEditReferences = 1;
      }
      if (Feature_NurseProfile_References[0].List === true) {
        this.CanShowReferences = 1;
      }
    }

    if (Feature_NurseProfile_Identities.length > 0) {
      if (Feature_NurseProfile_Identities[0].Edit === true) {
        this.CanEditIdentities = 1;
      }
      if (Feature_NurseProfile_Identities[0].List === true) {
        this.CanShowIdentities = 1;
      }
    }

    if (Feature_NurseProfile_Certifications.length > 0) {
      if (Feature_NurseProfile_Certifications[0].Edit === true) {
        this.CanEditCertifications = 1;
      }
      if (Feature_NurseProfile_Certifications[0].List === true) {
        this.CanShowCertifications = 1;
      }
    }

    if (Feature_NurseProfile_MedicalFitness.length > 0) {
      if (Feature_NurseProfile_MedicalFitness[0].Edit === true) {
        this.CanEditMedicalFitness = 1;
      }
      if (Feature_NurseProfile_MedicalFitness[0].List === true) {
        this.CanShowMedicalFitness = 1;
      }
    }

    if (Feature_NurseProfile_ProfileImage.length > 0) {
      if (Feature_NurseProfile_ProfileImage[0].Edit === true) {
        this.CanEditProfileImage = 1;
      }
      if (Feature_NurseProfile_ProfileImage[0].List === true) {
        this.CanShowProfileImage = 1;
      }
    }

    if (Feature_NurseProfile_Legalinfo.length > 0) {
      if (Feature_NurseProfile_Legalinfo[0].Edit === true) {
        this.CanEditLegalinfo = 1;
      }
      if (Feature_NurseProfile_Legalinfo[0].List === true) {
        this.CanShowLegalinfo = 1;
      }
    }
    this.IsSetAccessRights = true;





    //
  }
  //var PatientActorCode = this.ActorCode;


  //AddDetails() {
  //  const modalRef = this.modalService.open(NgbTcDetailsModal,
  //    {
  //      centered: true,
  //      size: "lg"
  //    })

  //}
  //AddEventDetails() {
  //  const modalRef = this.modalService.open(NgbEventAddModal,
  //    {
  //      centered: true

  //    })

  //}
  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentCycleSpermPreparationBetweenDateController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentCycleSpermPreparationBetweenDateController,
          this.listFilter);
      }
    }
  }

  showPage(page: string) {
    this.currentPage = page;
  }
  BackToProfile() {
    alert("method");
    this.router.navigate(['testnurse/dashboard']);

  }
  BackToTreatment() {
    alert("Thistrearment");
    this.router.navigate(['testnurse/ivfdashboard']);
  }
  onClick() {
    let x = document.querySelector("#psa");
    if (x) {
      x.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  pickUp() {
    let y = document.querySelector("#pickup");
    if (y) {
      y.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  ET() {
    let z = document.querySelector("#et");
    if (z) {
      z.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  InsuminationLog() {
    let m = document.querySelector("#IL");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  Grading() {
    let m = document.querySelector("#Grad");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  OQA() {
    let m = document.querySelector("#oqa");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  scans() {
    let m = document.querySelector("#scans");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  onpersonalInfoChange(event: any) {
    // console.log('onpersonalInfoChange');

    if (event != null) {

      this.ValueChangeActorPersonalInfoController = event;
      //console.log('this.ValueChangeActorPersonalInfoController.DisplayName--->' + this.ValueChangeActorPersonalInfoController.DisplayName);
      //this.ValueChangeActorPersonalInfoController.DisplayName = this.CurrentActorProfileController.DisplayName;
      if (this.ValueChangeActorPersonalInfoController.DisplayName != null) {
        this.CurrentActorProfileController.DisplayName = this.ValueChangeActorPersonalInfoController.DisplayName;
      }


    }

  }
  dataChanged(newobj) {

    this._GetCycleSpermPreparationBetweenDateController();
  }
  _GetCycleSpermPreparationBetweenDateController() {
    this.StartRefreshing();
    this.CurrentCycleSpermPreparationBetweenDateRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentCycleSpermPreparationBetweenDateRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));

    this.actorservice.GetCycleSpermPreparationBetweenDateController(this.CurrentCycleSpermPreparationBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCycleSpermPreparationBetweenDateController = this.ApiResData.Result;
          this.pdata = this.CurrentCycleSpermPreparationBetweenDateController;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  DecrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetCycleSpermPreparationBetweenDateController();
    //ind++;
  }
  IncrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetCycleSpermPreparationBetweenDateController();
    //ind++;
  }
  onactorImageInfoChange(event: any) {


    if (event != null) {

      this.ValueChangeActorImageController = event;

      if (this.ValueChangeActorImageController.ActorImageFileUrl != null) {
        //console.log('this.ValueChangeActorImageController.ActorImageFileUrl-->' + this.ValueChangeActorImageController.ActorImageFileUrl);

        this.CurrentActorProfileController.ActorImageFileUrl = this.ValueChangeActorImageController.ActorImageFileUrl;
      }


    }

  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  onChange($event) {
    // this.marked = event;
  }
  closeResult: string;
  // This function is used in open
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  // Open content with dark section
  //openContent() {
  //  alert('open dialog');
  //  if (this.CurrentActorProfileController.ActorImageCode != null && this.CurrentActorProfileController.ActorImageCode > 0) {
  //    const modalRef = this.modalService.open(NgbdUploadActorImageModal, {
  //      centered: true
  //    })
  //    modalRef.componentInstance.ActorImageCode = this.CurrentActorProfileController.ActorImageCode;
  //    modalRef.componentInstance.ActorCode = this.CurrentActorProfileController.ActorCode;
  //    modalRef.componentInstance.ActorImageFile == this.CurrentActorProfileController.ActorImageFile;
  //    modalRef.componentInstance.ActorImageFileExtension = this.CurrentActorProfileController.ActorImageFileExtension;

  //    modalRef.result.then(x => { this.GetActorProfileController() })

  //  }
  //  else {
  //    alertFunctions.AlertParam('you dont have Permission to Upload...!');
  //  }
  //}

  SelectedpatientDetails: CycleOocyteQualityBetweenDateController;

  Selectedpatient(objCategory: any) {
    var Patient: CycleOocyteQualityBetweenDateController = objCategory;
    if (Patient != null) {
      this.SelectedpatientDetails = null;
      this.SelectedpatientDetails = Patient;
      this.ScanDetails = true;
      this.LoadInsemination();
      this.LoadInsemination2();
      this.LoadOqaData();
      this.LoadCycles();
      this.LoadInseminationDatacycle();
      this.CanLoadReport = true;
      //this.LoadScansData();
      //this.LoadOvaryData();
      //this.LoadTestData();
      //this.LoadMedicineData();
    }

  }
  CurrentSingleWellInseminationByCycleController: SingleWellInseminationByCycleController[];
  CurrentSingleWellInseminationByCycleRequest: SingleWellInseminationByCycleRequest;
  LoadInsemination() {
    this.CurrentSingleWellInseminationByCycleRequest = new SingleWellInseminationByCycleRequest();
    this.CurrentSingleWellInseminationByCycleRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSingleWellInseminationByCycleRequest.ConditionalOperator = 10;
    this.CurrentSingleWellInseminationByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetSingleWellInseminationByCycleController();
  }
  GetSingleWellInseminationByCycleController() {
    //this.StartRefreshing();


    this.actorservice.GetSingleWellInseminationByCycleController(this.CurrentSingleWellInseminationByCycleRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentSingleWellInseminationByCycleController = this.ApiResData.Result;
          this.length = this.CurrentSingleWellInseminationByCycleController.length;
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //  this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  onSubmit(data: SingleWellInseminationByCycleController) {


    this.CurrentSaveSingleWellInseminationInfoRequest.ConditionalOperator = 1;
    this.CurrentSaveSingleWellInseminationInfoRequest.InseminationDate = new Date();
    this.CurrentSaveSingleWellInseminationInfoRequest.WellFollicle = data.WellFollicle;
    this.CurrentSaveSingleWellInseminationInfoRequest.technique = data.technique;



    this.actorservice.SaveSingleWellInseminationInfo(this.CurrentSaveSingleWellInseminationInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.LoadInsemination();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );


  }
  CurrentIvfCycleInseminationLogByCycleWithDOCController: IvfCycleInseminationLogByCycleWithDOCController[];
  InseminationEndInfo: IvfCycleInseminationLogByCycleWithDOCController;
  CurrentIvfCycleInseminationLogByCycleWithDOCRequest: IvfCycleInseminationLogByCycleWithDOCRequest;
  LoadInsemination2() {
    this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest = new IvfCycleInseminationLogByCycleWithDOCRequest();
    this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest.DOC = 1;
    this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest.ConditionalOperator = 10;
    this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleInseminationLogByCycleWithDOCController();
  }
  GetIvfCycleInseminationLogByCycleWithDOCController() {
    // this.StartRefreshing();


    this.actorservice.GetIvfCycleInseminationLogByCycleWithDOCController(this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentIvfCycleInseminationLogByCycleWithDOCController = this.ApiResData.Result;
          this.InseminationEndInfo = this.CurrentIvfCycleInseminationLogByCycleWithDOCController[0];
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          // this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  //Selectedpatient() {
  //  this.ScanDetails = true;
  //}
  CurrentIvfOocyteEmbryoStorageByCodeController: IvfOocyteEmbryoStorageByCodeController[];
  CurrentIvfOocyteEmbryoStorageByCodeRequest: IvfOocyteEmbryoStorageByCodeRequest;

  LoadOqaData() {
    //alert("ScansData")
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest = new IvfOocyteEmbryoStorageByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfOocyteEmbryoStorageByCodeController();
  }

  GetIvfOocyteEmbryoStorageByCodeController() {
    //this.StartRefreshing();

    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.SelectedpatientDetails.EggSourceActorCode;

    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ConditionalOperator = 10;

    //alert(this.FormattedCode);
    this.actorservice.GetIvfOocyteEmbryoStorageByCodeController(this.CurrentIvfOocyteEmbryoStorageByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfOocyteEmbryoStorageByCodeController = this.ApiResData.Result;
          // this.length = this.CurrentIvfOocyteEmbryoStorageByCodeController.length;

          //this.OocyteQADetails = this.CurrentOocyteQualityAssessmentByCodeController[0];
          //this.CurrentOocyteQualityAssessmentByCodeController = new Array<OocyteQualityAssessmentByCodeController>();
          //var data = this.ApiResData.Result as Array<OocyteQualityAssessmentByCodeController>;

          //data.forEach((v, i, a) => {
          //    this.CurrentOocyteQualityAssessmentByCodeController.push(v);
          //});
          //for (let index = 0; index < data.length; index++){
          //    //alert(data[index].SingleWellFollicleCoder);

          //    this.CurrentOocyteQualityAssessmentByCodeController.push(data[index]);
          //}
          //    this.FollicularOocyteInfo = this.CurrentOocyteQualityAssessmentByCodeController[0];
          //   alert(this.FollicularOocyteInfo.TreatmentCycle);
          //if (this.FollicularScanEndInfo.ScanDate != null) {
          //  var SValidFrom = new Date(this.FollicularScanEndInfo.ScanDate);
          //  if (SValidFrom.getFullYear() > 1900) {
          //    console.log('this.UpdateDate >1990');
          //    this.ScanDate = {

          //      year: SValidFrom.getFullYear(),
          //      month: SValidFrom.getMonth() + 1,
          //      day: SValidFrom.getDate()
          //    }
          //  }
          //}
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          // this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          this.LoadPatients();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
  ActorCodeDetails: TreatmentCyclesByActorCodeController;
  CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
  LoadPatients() {
    this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = this.ActorCode;
    this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCyclesByActorCodeController();
  }

  GetTreatmentCyclesByActorCodeController() {
    //this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
          this.ActorCodeDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();
          this.LoadDSAData();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  ActorCodeLoad() {
    //alert("ActorCode");
    var SelectedActorCode = this.ActorCodeDetails.EggActorCode;
    return SelectedActorCode;
  }
  GetActorCode(EggSourceType: string): number {
    // alert("new");
    if (EggSourceType == 'Donor') {
      var DonorActorCode = this.ActorCodeDetails.EggActorCode;
      return DonorActorCode;
    }
    else if (EggSourceType == 'Self') {
      var OwnerActorCode = this.SelectedpatientDetails.EggSourceActorCode;
      return OwnerActorCode;
    }
  }
  CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
  DSADetails: DSAActivityByCycleCodeController;
  CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;

  LoadDSAData() {
    //alert("ScansData")
    this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDSAActivityByCycleCodeController();
  }

  GetDSAActivityByCycleCodeController() {
    //this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 10;
    this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //alert(this.FormattedCode);
    this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;
          this.DSADetails = this.GetCycleActivity(this.GetActorCode(this.SelectedpatientDetails.EggSourceType), this.SelectedpatientDetails.ProtocolStartDate)[0];
          //alert(this.DSADetails);
          //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
          //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
          //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

          //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
          //var list = this.CurrentDSAActivityByCycleCodeController.filter(


          //    function (a) {
          //        var Date = this.FollicularScanEndInfo.ScanDate;
          //        var ActorCode = this.SelectedpatientDetails.ActorID;
          //        return a.ActivityDate == Date && a.ActorCode == ActorCode
          //    });

          //this.CurrentDSAActivityByCycleCodeController = list;
          //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
          //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
          //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
          //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
          //alert(this.Doc1);
          //alert(this.Antag);
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  //    GetDsADetails(ActorCode: number, Date: Date) {


  //}
  GetCycleActivity(ReceipientActorCode: number, TransferDateNew: Date): DSAActivityByCycleCodeController[] {
    //alert(ReceipientActorCode);
    //alert(TransferDateNew);
    return this.CurrentDSAActivityByCycleCodeController.filter(
      function (v, i, d) {

        return v.ActorCode == ReceipientActorCode && v.ActivityDate == TransferDateNew;
      }
    )

  }
  Addactivity() {
    const modalRef = this.modalService.open(NgbAddInseminationLogModal,
      {
        centered: true,
        backdrop: 'static',
        keyboard: false

      })
    modalRef.componentInstance.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    modalRef.componentInstance.Gradingmodel = this.SelectedpatientDetails.GradingModel;
    modalRef.componentInstance.Doctor = this.InseminationEndInfo.Doctor;
    modalRef.componentInstance.ProcessedBy = this.InseminationEndInfo.ProcessedBy;
    modalRef.componentInstance.Nurse = this.InseminationEndInfo.Nurse;
    modalRef.result.then(x => { this.GetIvfCycleInseminationLogByCycleWithDOCController() })
    //modalRef.componentInstance.InseminationTime = this.InseminationEndInfo.InseminationTime;

  }
  AddInsemination() {
    const modalRef = this.modalService.open(NgbEditInsemiModal,
      {
        centered: true,
        backdrop: 'static',
        keyboard: false

      })
    modalRef.componentInstance.Mode = "New";
    modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    modalRef.result.then(x => { this.GetIvfCycleInseminationByCycleController() })
  }
  Editinsemi(datanew: IvfCycleInseminationByCycleController) {
    this.CurrentEditIvfCycleInseminationInfoRequest.ConditionalOperator = 20;
    this.CurrentEditIvfCycleInseminationInfoRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentEditIvfCycleInseminationInfoRequest.OocyteCount = datanew.OocyteCount;
    this.CurrentEditIvfCycleInseminationInfoRequest.InseminationCode = datanew.InseminationCode;
    this.CurrentEditIvfCycleInseminationInfoRequest.Technique = datanew.Technique;
    this.CurrentEditIvfCycleInseminationInfoRequest.PrescribedBy = datanew.PrescribedBy;
    this.CurrentEditIvfCycleInseminationInfoRequest.PrescribedByName = datanew.PrescribedByName;
    this.CurrentEditIvfCycleInseminationInfoRequest.Remarks = datanew.Remarks;


    const modalRef = this.modalService.open(NgbEditInsemiModal,
      {
        centered: true

      })
    modalRef.componentInstance.Mode = "Edit";
    modalRef.componentInstance.CurrentEditIvfCycleInseminationInfoRequest = this.CurrentEditIvfCycleInseminationInfoRequest;
    modalRef.result.then(x => { this.GetIvfCycleInseminationByCycleController() })
  }

  Editactivity(l: IvfCycleInseminationLogByCycleWithDOCController) {
    this.CurrentSaveIvfCycleInseminationLogRequest.InseminationDate = l.InseminationDate;
    this.CurrentSaveIvfCycleInseminationLogRequest.InseminationTime = l.InseminationTime;
    this.CurrentSaveIvfCycleInseminationLogRequest.DateofCollection = l.DateofCollection;
    this.CurrentSaveIvfCycleInseminationLogRequest.TimeofCollection = l.TimeofCollection;
    this.CurrentSaveIvfCycleInseminationLogRequest.TreatmentCycleCode = l.TreatmentCycle;
    this.CurrentSaveIvfCycleInseminationLogRequest.Doc = l.IterationType;
    this.CurrentSaveIvfCycleInseminationLogRequest.DoctorName = l.DoctorName;
    this.CurrentSaveIvfCycleInseminationLogRequest.Doctor = l.Doctor;
    this.CurrentSaveIvfCycleInseminationLogRequest.NtimesInformed = l.NtimesInformed;
    this.CurrentSaveIvfCycleInseminationLogRequest.IterationType = l.IterationType;
    this.CurrentSaveIvfCycleInseminationLogRequest.Nurse = l.Nurse;
    this.CurrentSaveIvfCycleInseminationLogRequest.NurseName = l.NurseName;
    this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedBy = l.ProcessedBy;
    this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedByName = l.ProcessedByName;
    this.CurrentSaveIvfCycleInseminationLogRequest.SlideObserved = l.SlideObserved;
    this.CurrentSaveIvfCycleInseminationLogRequest.Patient = l.Patient;
    this.CurrentSaveIvfCycleInseminationLogRequest.InseminationLogCode = l.InseminationLogCode;
    this.CurrentSaveIvfCycleInseminationLogRequest.InseminationTimeText = l.InseminationTimeText;
    this.CurrentSaveIvfCycleInseminationLogRequest.RecordStatus = l.RecordStatus;
    const modalRef = this.modalService.open(NgbEditInseminationLogModal,
      {
        centered: true,
        backdrop: 'static',
        keyboard: false

      })
    modalRef.componentInstance.Gradingmodel = this.SelectedpatientDetails.GradingModel;
    modalRef.componentInstance.CurrentSaveIvfCycleInseminationLogRequest = this.CurrentSaveIvfCycleInseminationLogRequest;
    modalRef.result.then(x => { this.GetIvfCycleInseminationLogByCycleWithDOCController() })
  }
  Insemination() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.IsinseminationCompleted();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })
  }

  IsinseminationCompleted() {


    console.log('..................');
    // this.StartRefreshing();
    //this.CurrentCompleteIvfCycleInseminationRequest.ConditionalOperator = 3;
    this.CurrentCompleteIvfCycleInseminationRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentCompleteIvfCycleInseminationRequest.DateOfInsemination = this.InseminationEndInfo.InseminationDate;
    this.CurrentCompleteIvfCycleInseminationRequest.TimeOfInsemination = this.InseminationEndInfo.InseminationTime;
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.CompleteIvfCycleInsemination(this.CurrentCompleteIvfCycleInseminationRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.ShowList = true;
            //this.LoadMedicineData();

            //this.stopRefreshing();
            this.LoadCycles();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
  InseminationData: TreatmentCycleStatusController[];
  InseminationData2: TreatmentCycleStatusController;
  CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
  LoadCycles() {
    this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetTreatmentCycleStatusController();
  }

  GetTreatmentCycleStatusController() {
    // this.StartRefreshing();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

    this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
          this.InseminationData = this.ApiResData.Result;
          var Inseminationlist = this.InseminationData.filter(
            function (g) {
              return g.PhaseActivity == "Insemination";
            });
          this.InseminationData = Inseminationlist;
          this.InseminationData2 = this.InseminationData[0];
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          // this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  InseminationIUI() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.IsInseminationIUICompleted();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })
  }

  IsInseminationIUICompleted() {


    console.log('..................');
    // this.StartRefreshing();
    this.CurrentCompleteIvfCycleInseminationRequest.ConditionalOperator = 1;
    this.CurrentCompleteIvfCycleInseminationRequest.CycleCode = this.CycleCode;
    this.CurrentCompleteIvfCycleInseminationRequest.DateOfInsemination = this.InseminationEndInfo.InseminationDate;
    this.CurrentCompleteIvfCycleInseminationRequest.TimeOfInsemination = this.InseminationEndInfo.InseminationTime;
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.CompleteIvfCycleInsemination(this.CurrentCompleteIvfCycleInseminationRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.ShowList = true;
            //this.LoadMedicineData();

            //this.stopRefreshing();
            this.LoadCycles();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  CurrentIvfCycleInseminationByCycleController: IvfCycleInseminationByCycleController[];
  CurrentIvfCycleInseminationByCycleRequest: IvfCycleInseminationByCycleRequest;

  LoadInseminationDatacycle() {
    //alert("ScansData")
    this.CurrentIvfCycleInseminationByCycleRequest = new IvfCycleInseminationByCycleRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleInseminationByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleInseminationByCycleController();
  }

  GetIvfCycleInseminationByCycleController() {
    // this.StartRefreshing();

    this.CurrentIvfCycleInseminationByCycleRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;

    //alert(this.FormattedCode);
    this.actorservice.GetIvfCycleInseminationByCycleController(this.CurrentIvfCycleInseminationByCycleRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfCycleInseminationByCycleController = this.ApiResData.Result;


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  delLog(l: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteLog(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteLog(l: any) {
    var item = l as IvfCycleInseminationLogByCycleWithDOCController;



    console.log('..................');
    // this.StartRefreshing();
    this.CurrentSaveIvfCycleInseminationLogRequest.ConditionalOperator = 20;
    this.CurrentSaveIvfCycleInseminationLogRequest.InseminationDate = item.InseminationDate;
    this.CurrentSaveIvfCycleInseminationLogRequest.InseminationTime = item.InseminationTime;
    this.CurrentSaveIvfCycleInseminationLogRequest.DateofCollection = item.DateofCollection;
    this.CurrentSaveIvfCycleInseminationLogRequest.TimeofCollection = item.TimeofCollection;
    this.CurrentSaveIvfCycleInseminationLogRequest.TreatmentCycleCode = item.TreatmentCycle;
    this.CurrentSaveIvfCycleInseminationLogRequest.Doc = item.IterationType;
    this.CurrentSaveIvfCycleInseminationLogRequest.DoctorName = item.DoctorName;
    this.CurrentSaveIvfCycleInseminationLogRequest.Doctor = item.Doctor;
    this.CurrentSaveIvfCycleInseminationLogRequest.NtimesInformed = item.NtimesInformed;
    this.CurrentSaveIvfCycleInseminationLogRequest.IterationType = item.IterationType;
    this.CurrentSaveIvfCycleInseminationLogRequest.Nurse = item.Nurse;
    this.CurrentSaveIvfCycleInseminationLogRequest.NurseName = item.NurseName;
    this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedBy = item.ProcessedBy;
    this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedByName = item.ProcessedByName;
    this.CurrentSaveIvfCycleInseminationLogRequest.SlideObserved = item.SlideObserved;
    this.CurrentSaveIvfCycleInseminationLogRequest.Patient = item.Patient;
    this.CurrentSaveIvfCycleInseminationLogRequest.InseminationLogCode = item.InseminationLogCode;
    this.CurrentSaveIvfCycleInseminationLogRequest.InseminationTimeText = item.InseminationTimeText;
    this.CurrentSaveIvfCycleInseminationLogRequest.RecordStatus = item.RecordStatus;


    //this.CurrentSaveIvfCycleTestDataRequest.FollicularGrowth = this.SelectedpatientDetails.FollicularGrowthCode;
    //this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.SelectedpatientDetails.PatientCode;
    //this.CurrentSaveIvfCycleInseminationLogRequest.ActorCode = this.SelectedpatientDetails.ActorID;

    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.SaveIvfCycleInseminationLog(this.CurrentSaveIvfCycleInseminationLogRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            //this.ShowList = true;
            //this.LoadOvaryData();
            this.LoadInsemination2();
            //this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }

  BackTodashboard() {
    //this.Showivf = true;
    //this.ShowIninsemination= false;
    this.router.navigate(['healins/ivfworkbench']);
  }
  printinsemi() {
    this.printService.printDocument("inseminationlog",
      {
        Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
        TreatmentCycleCodedata: this.SelectedpatientDetails.TreatmentCycleCode, ActorCodedata: this.SelectedpatientDetails.EggSourceActorCode, TotalOocytes: this.SelectedpatientDetails.TotalOocytes, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate,
        InsemDate: this.InseminationEndInfo.InseminationDate, InsemTime: this.InseminationEndInfo.InseminationTime, NtimesInf: this.InseminationEndInfo.NtimesInformed, ProcessedBy: this.InseminationEndInfo.ProcessedByName, Doctor: this.InseminationEndInfo.DoctorName, Details: this.InseminationEndInfo.IterationType, Nurse: this.InseminationEndInfo.NurseName,

      }
    );
  }
  printinsemidroplet() {
    this.printService.printDocument2(this.SelectedpatientDetails.OwnerFormattedCode, 0

    );
    this.printService.printDocument("inseminationlogdroplet",
      {
        Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
        TreatmentCycleCodedata: this.SelectedpatientDetails.TreatmentCycleCode, ActorCodedata: this.SelectedpatientDetails.EggSourceActorCode, TotalOocytes: this.SelectedpatientDetails.TotalOocytes, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate,
        EggSourceData: this.ActorCodeDetails.EggSourceType, DonorData: this.ActorCodeDetails.EggName, DonorCode: this.ActorCodeDetails.EggFormattedCode, InsemDate: this.InseminationEndInfo.InseminationDate, InsemTime: this.InseminationEndInfo.InseminationTimeText, NtimesInf: this.InseminationEndInfo.NtimesInformed, ProcessedBy: this.InseminationEndInfo.ProcessedByName, Doctor: this.InseminationEndInfo.DoctorName, Details: this.InseminationEndInfo.IterationType, Nurse: this.InseminationEndInfo.NurseName,

      }
    );
  }
}
